import z from 'zod';
import { DocumentMetaTs, LocaleTs } from "../../common";
import { SingleTypes } from '@/providers/strapi';
import { ContentContext } from '../../content-provider';
import { useContext } from 'react';
import { OmitDocumentMeta } from '@/providers/strapi/client/types';




export type Calculator = z.output<typeof CalculatorTs>;
export const CalculatorTs = DocumentMetaTs.extend({
  id: z.int(),
  locale: LocaleTs,
  localizations: z.array(DocumentMetaTs),
  title: z.string(),
  countryTabLabel: z.string(),
  france: z.string(),
  spain: z.string(),
  belgium: z.string(),
  amountInputLabel: z.string(),
  inputSuffix: z.string(),
  inputHint: z.string(),
  resultCardTitle: z.string(),
  resultCardHint: z.string(),
  info1: z.string(),
  info2: z.string(),
  disclaimer: z.string(),
  mobileTitle: z.string(),
  mobileCta: z.string()
})

export const CALCULATOR = "calculator";
export function useCalculatorComponent<
  K extends keyof Omit<Calculator, "id" | "locale" | "localizations" | OmitDocumentMeta>
>(
  entity: K,
  // contextKey: string
): Calculator[K] {
  const content: Record<string, SingleTypes> | null = useContext(ContentContext);
  if (!content) throw new Error(`Calculator content not found`)
  const Calculator = content[CALCULATOR] as Calculator;
  if (!Calculator || !Calculator[entity]) throw new Error(`${entity} content not found`)
  return Calculator[entity]
}


// type HomePageContentMap = {
//   retailer: RetailerHomePage;
//   traveler: TravelerHomePage;
// };

// type ValidPageKey = keyof HomePageContentMap;

// type FilteredKeys<T> = keyof Omit<T, "id" | "locale" | "localizations" | OmitDocumentMeta>;

// export function useContent<
//   PageKey extends ValidPageKey,
//   T extends HomePageContentMap[PageKey],
//   K extends FilteredKeys<T>
// >(
//   pageKey: PageKey,
//   entity: K
// ): T[K] {
//   const content = useContext(ContentContext);

//   if (!content) {
//     throw new Error(`${String(pageKey)} content not found`);
//   }

//   const homePage = content[pageKey] as T;

//   const value = homePage?.[entity];
//   if (value === undefined) {
//     throw new Error(`${String(entity)} content not found in ${String(pageKey)}`);
//   }

//   return value;
// }
